export enum IndustryCatalogType {
  Unknown = 'Unknown',
  PurchasingGroup = 'PurchasingGroup',
  Manufacturer = 'Manufacturer',
  Dealer = 'Dealer',
  Hybrid = 'Hybrid',
}
